import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">{aboutInfo.title}</h2>
        </div>
        <p className="text-sm md:text-base text-foreground-500 max-w-3xl mx-auto leading-relaxed">
          {aboutInfo.description}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-8">
          {aboutInfo.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-black text-primary-500">{stat.value}</div>
              <div className="text-xs md:text-sm text-foreground-400 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}